import { Alert, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { secondAxios } from "../../../../../api/axios";
import ChangeOrderTable from "./ChangeOrderTable";
import useDocumentTitle from "../../../../../hooks/useDocumentTitle";
import DownloadablePage from "../../../../../components/DownloadablePage";
import PageHeader from "../../../../../components/PageHeader";

export default function CMSPage() {
  useDocumentTitle("CMS");
  const { plantId } = useParams();

  const [tableData, setTableData] = useState([]);
  const [plant, setPlant] = useState({});

  async function getCOs() {
    const res = await secondAxios.get(`/change-order/plant/${plantId}`);
    setTableData(res?.data || []);
  }

  const getPlant = async () => {
    const res = await secondAxios.get(`/plant/${plantId}`);
    setPlant(res?.data || {});
  };
  useEffect(() => {
    getCOs();
    getPlant();
  }, []);

  return (
    <DownloadablePage fileName="ChinookDT-CMS.pdf">
      <Box sx={{ p: 2, pt: 0 }}>
        <PageHeader
          plant={{ id: plantId, ...plant }}
          pageTitle="CMS (Change Management System)"
          moduleKey="cms"
        />

        {/* Change orders are raised in PMS, from the drawing BOM's revision
            compare (COForm) - this page lists and tracks them. */}
        <Alert severity="info" className="no-export" sx={{ my: 2 }}>
          Change orders are raised in PMS: open a drawing's BOM, compare two
          revisions and create the change order from the differences.
        </Alert>

        <ChangeOrderTable coTableData={tableData} />
      </Box>
    </DownloadablePage>
  );
}
